import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getEmailRecipient = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/EmailRecipient`
  );
  return data;
};
export const getEmailPermission = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/EmailPermission`
  );
  return data;
};

export const getFieldsOwned = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/GetFieldsOwned`
  );
  return data;
};
export const getOperationGroupMapping = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/GetEmailGroupMapping`
  );
  return data;
};
export const getFields = async () => {
  const { data } = await axios.get(`${api_base_url}/Configuration/GetFields`);
  return data;
};
// Insert New EmailRecipient
export const addEmailRecipient = async (newEmailRecipient) => {
  const { data } = await axios.post(
    `${api_base_url}/Configuration/EmailRecipient`,
    {
      ...newEmailRecipient[0],
    }
  );
  return data;
};
// Update EmailRecipientS
export const updateEmailRecipient = async (EmailRecipientNewData) => {
  const { data } = await axios.put(
    `${api_base_url}/Configuration/EmailRecipient/${EmailRecipientNewData[0]?.autoEmailNotificationId}`,
    {
      ...EmailRecipientNewData[0],
    }
  );
  return data;
};

export const deleteEmailRecipient = async (EmailRecipientId) => {
  await axios.delete(`${api_base_url}/Configuration/EmailRecipient`, {
    data: EmailRecipientId,
  });
};
